import { IDictionaryWordMap } from '../../../interfaces/Dictionary.interfaces';
import { customAxios } from '../../common/customAxios';

export const getDictionaryWordMap = (): Promise<IDictionaryWordMap> => {
  return customAxios.get('/dictionary/word-map');
};
